"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var Back4app2Error_1 = require("./Back4app2Error");
var AgentCharLimitExceededError = /** @class */ (function (_super) {
    __extends(AgentCharLimitExceededError, _super);
    function AgentCharLimitExceededError(message) {
        var _this = _super.call(this, message, AgentCharLimitExceededError.CODE) || this;
        Object.setPrototypeOf(_this, AgentCharLimitExceededError.prototype);
        return _this;
    }
    AgentCharLimitExceededError.CODE = 'AGENT_CHAR_LIMIT_EXCEEDED_ERROR';
    return AgentCharLimitExceededError;
}(Back4app2Error_1["default"]));
exports["default"] = AgentCharLimitExceededError;
